import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import favicon from 'images/icons/everlywell-favicon-32x32.png';
import React from 'react';
import { schemaOrgJSONLD } from 'utils/constants/jsondl';

import { useSEO } from '../../templates/use-site-metadata';
import { SEOProps } from './seo';

/** Datadog initialization */
const ddConfig = {
  clientToken: process.env.DATADOG_CLIENT_TOKEN || '',
  site: 'datadoghq.com',
  service: 'everlyhealthsolutions',
  env: process.env.REACT_APP_ENV,
  sampleRate: 100,
  silentMultipleInit: true,
};

datadogRum.init({
  ...ddConfig,
  applicationId: process.env.DATADOG_APPLICATION_ID || '',
  premiumSampleRate: 0,
  trackInteractions: true,
});

datadogLogs.init({
  ...ddConfig,
  forwardErrorsToLogs: true,
  telemetrySampleRate: 0,
});

export const SEO = (props: SEOProps) => {
  const seo = useSEO(props);

  return (
    <>
      {/* Schema.org tags */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgJSONLD)}
      </script>
      {/* General tags */}
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      {/* link rel='canonical' is being dynamically generated at gatsby.config */}
      <link rel="icon" href={favicon} />
      {/* Font stylesheet - moved from global.tsx to avoid @import in createGlobalStyle */}
      <link
        rel="stylesheet"
        href="https://cdn.everlywell.com/fonts/everly-font.css"
      />
      {/* OpenGraph tags */}
      <meta property="og:title" content={seo.title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={seo.url} />
      <meta property="og:description" content={seo.description} />
      {seo.image && <meta property="og:image" content={seo.image} />}
      {seo.image && <meta property="og:image:alt" content={seo.title} />}
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={seo.userTwitter} />
      <meta name="twitter:title" content={seo.siteTitle} />
      <meta name="twitter:description" content={seo.siteDescription} />
      {seo.image && <meta name="twitter:image" content={seo.image} />}
      {seo.image && <meta name="twitter:image:alt" content={seo.title} />}
    </>
  );
};
